<div>
  <form [formGroup]="streetAddressForm" class="form-padding-top">
    <div><h3>Address Information</h3></div>
    <div class="row row-padding">
      <!--This is the street address if above checkbox is selected-->
      <div class="col-md-3 form-group">
        <label
          >Street Address<span class="required-field-asterisk">*</span></label
        >
        <input class="form-control" type="text" formControlName="address1" />
      </div>

      <div class="col-md-3 form-group">
        <label>Street Address 2</label>
        <input class="form-control" type="text" formControlName="address2" />
      </div>

      <div class="col-md-2 form-group">
        <label>City<span class="required-field-asterisk">*</span></label>
        <input class="form-control" type="text" formControlName="city" />
      </div>

      <div class="col-md-2 form-group">
        <label
          >{{ localizationInfo.territory.label
          }}<span class="required-field-asterisk">*</span></label
        >

        @if (states) {
          <app-select-dropdown
            [control]="streetAddressForm.controls['state']"
            [options]="states"
            [placeholder]="''"
            [dropdownId]="'street-state-dropdown'"
          ></app-select-dropdown>
        }
      </div>

      <div class="col-md-2 form-group">
        <label
          >{{ localizationInfo.postalCode.label
          }}<span class="required-field-asterisk">*</span></label
        >
        <input
          class="form-control"
          type="text"
          formControlName="zip"
          placeholder="{{ localizationInfo.postalCode.format }}"
          [inputMask]="country === 'US' ? usZipMask : canadianZipMask"
        />
      </div>
    </div>
  </form>

  <div class="row">
    <!--Checkbox to display separate street address (below row)-->
    <div class="col-md-12 check-group">
      <input
        class="form-check-input"
        type="checkbox"
        id="mailing-address-confirmation"
        [ngModel]="streetAddressForm.controls['isMailing'].value"
        (ngModelChange)="applyIsMailingToAddress($event)"
      />
      <label for="mailing-address-confirmation" class="form-check-label"
        >My mailing address is the same as my street address.</label
      >
    </div>
  </div>

  @if (mailingAddressForm.controls['isMailing'].value) {
    <form [formGroup]="mailingAddressForm">
      <div class="row row-padding">
        <div class="col-md-3 form-group">
          <label
            >Mailing Address<span class="required-field-asterisk"
              >*</span
            ></label
          >
          <input class="form-control" type="text" formControlName="address1" />
        </div>
        <div class="col-md-3 form-group">
          <label>Mailing Address 2</label>
          <input class="form-control" type="text" formControlName="address2" />
        </div>
        <div class="col-md-2 form-group">
          <label>City<span class="required-field-asterisk">*</span></label>
          <input class="form-control" type="text" formControlName="city" />
        </div>
        <div class="col-md-2 form-group">
          <label
            >{{ localizationInfo.territory.label
            }}<span class="required-field-asterisk">*</span></label
          >
          @if (states) {
            <app-select-dropdown
              [control]="mailingAddressForm.controls['state']"
              [options]="states"
              [placeholder]="''"
              [dropdownId]="'mailing-state-dropdown'"
            ></app-select-dropdown>
          }
        </div>
        <div class="col-md-2 form-group">
          <label
            >{{ localizationInfo.postalCode.label
            }}<span class="required-field-asterisk">*</span></label
          >
          <input
            class="form-control"
            type="text"
            formControlName="zip"
            placeholder="{{ localizationInfo.postalCode.format }}"
            [inputMask]="country === 'US' ? usZipMask : canadianZipMask"
          />
        </div>
      </div>
    </form>
  }

  <div class="row">
    <!--Checkbox to display remit-to address (below row)-->
    <div class="col-md-12 check-group">
      <input
        class="form-check-input"
        type="checkbox"
        id="remit-address-confirmation"
        [ngModel]="
          mailingAddressForm.controls['isRemitTo'].value ||
          streetAddressForm.controls['isRemitTo'].value
        "
        (ngModelChange)="applyIsRemitToToAddress($event)"
      />
      <label for="remit-address-confirmation" class="form-check-label"
        >My remit-to address is the same as my mailing address</label
      >
    </div>
  </div>

  @if (remitToAddressForm.controls['isRemitTo'].value) {
    <form [formGroup]="remitToAddressForm">
      <div class="row row-padding">
        <!--This is the remit-to address if above checkbox is selected-->
        <div class="col-md-3 form-group">
          <label
            >Remit-to Address<span class="required-field-asterisk"
              >*</span
            ></label
          >
          <input class="form-control" type="text" formControlName="address1" />
        </div>
        <div class="col-md-3 form-group">
          <label>Remit-to Address 2</label>
          <input class="form-control" type="text" formControlName="address2" />
        </div>
        <div class="col-md-2 form-group">
          <label>City<span class="required-field-asterisk">*</span></label>
          <input class="form-control" type="text" formControlName="city" />
        </div>
        <div class="col-md-2 form-group">
          <label
            >{{ localizationInfo.territory.label
            }}<span class="required-field-asterisk">*</span></label
          >
          @if (states) {
            <app-select-dropdown
              [control]="remitToAddressForm.controls['state']"
              [options]="states"
              [placeholder]="''"
              [dropdownId]="'remit-to-state-dropdown'"
            ></app-select-dropdown>
          }
        </div>
        <div class="col-md-2 form-group">
          <label
            >{{ localizationInfo.postalCode.label
            }}<span class="required-field-asterisk">*</span></label
          >
          <input
            class="form-control"
            type="text"
            formControlName="zip"
            placeholder="{{ localizationInfo.postalCode.format }}"
            [inputMask]="country === 'US' ? usZipMask : canadianZipMask"
          />
        </div>
      </div>
    </form>
  }
</div>
